import React, { Component } from "react";

class FileUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachments: [],
      hoverIndex: null,
      showModal: false,
      previewImage: null,
      error: null, // Add state to manage error messages
    };
  }

  componentDidMount() {
    const { attachments } = this.props;
    if (attachments) {
      this.setState({ attachments });
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.attachments !== prevProps.attachments) {
      this.setState({ attachments: this.props.attachments });
    }
  }

  // onChangeFile = (e) => {
  //   const files = Array.from(e.target.files);
  //   const { attachments } = this.state;
  //   let validFiles = [];
  //   let error = null;

  //   files.forEach((file) => {
  //     if (file.size > 2 * 1024 * 1024) {
  //       // Check if file size exceeds 2MB
  //       error = `File "${file.name}" exceeds the 2MB size limit.`;
  //     } else {
  //       validFiles.push(file);
  //     }
  //   });

  //   if (error) {
  //     this.setState({ error });
  //   } else {
  //     this.setState(
  //       {
  //         attachments: [...attachments, ...validFiles],
  //         error: null, // Clear the error message
  //       },
  //       () => {
  //         if (this.props.onFileChange) {
  //           this.props.onFileChange(this.state.attachments);
  //         }
  //       }
  //     );
  //   }
  // };

  onChangeFile = (e) => {
    const files = Array.from(e.target.files);
    const { attachments } = this.state;
    const { maxFiles } = this.props;

    let newAttachments;
    
    if (maxFiles !== undefined) {
      // If maxFiles is specified, limit the total number of files
      const remainingSlots = maxFiles - attachments.length;
      const filesToAdd = files.slice(0, remainingSlots);
      newAttachments = [...attachments, ...filesToAdd];
    } else {
      // No limit, add all files
      newAttachments = [...attachments, ...files];
    }

    this.setState(
      {
        attachments: newAttachments,
        error: null,
      },
      () => {
        if (this.props.onFileChange) {
          this.props.onFileChange(this.state.attachments);
        }
      }
    );
  };

  handleDelete = (index) => {
    const { attachments } = this.state;
    attachments.splice(index, 1);
    this.setState({ attachments }, () => {
      if (this.props.onFileChange) {
        this.props.onFileChange(this.state.attachments);
      }
    });
  };

  handlePreview = (index) => {
    this.setState({
      previewImage: this.state.attachments[index],
      showModal: true,
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      previewImage: null,
    });
  };

  handleMouseEnter = (index) => {
    this.setState({ hoverIndex: index });
  };

  handleMouseLeave = () => {
    this.setState({ hoverIndex: null });
  };

  render() {
    const { attachments, hoverIndex, showModal, previewImage, error } =
      this.state;
    const { label, maxFiles } = this.props;
    
    const isDisabled = this.props.disabled || (maxFiles !== undefined && attachments.length >= maxFiles);

    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".bmp", ".webp"];

    const isImageUrl = (file) => {
      const extension = file?.split(".").pop().toLowerCase();
      return imageExtensions.includes(`.${extension}`);
    };
    // console.log("this.props?.accept: ", this.props?.accept);
    return (
      <>
        <div>
          <label
            className="custom-file-upload"
            style={{ 
              cursor: isDisabled ? "not-allowed" : "pointer",
              opacity: isDisabled ? 0.6 : 1
            }}
          >
            <input
              type="file"
              multiple={maxFiles === undefined || maxFiles > 1}
              onChange={this.onChangeFile}
              disabled={isDisabled}
              style={{ display: "none" }}
              className="custom-file-upload"
              accept={
                this.props?.accept
                  ? this.props.accept
                  : ".jpg,.jpeg,.png,.gif,.bmp,.svg,.webp,.pdf"
              }
            />
            <div
              className="upload-btn d-flex justify-content-center align-items-center text-center flex-column pre-wrap"
              style={{
                backgroundColor: isDisabled ? "#e9ecef" : "#fafafa",
                padding: "5px",
                borderRadius: "4px",
                fontSize: "14px",
                border: isDisabled ? "1px dashed #ccc" : "1px dashed #333",
                width: "100px",
                maxWidth: "150px",
                height: "110px",
                marginBottom: "1rem",
                cursor: isDisabled ? "not-allowed" : "pointer",
              }}
            >
              <div>
                <i className="bi bi-upload" title="Upload files"></i>
              </div>
              {label}
            </div>
          </label>
        </div>
        <div style={{ display: "flex", flexWrap: "wrap" }}>
          {attachments.map((file, index) => {
            const isImage =
              typeof file === "string"
                ? isImageUrl(file)
                : isImageUrl(file.name);
            const previewSrc =
              typeof file === "string" ? file : URL.createObjectURL(file);

            return (
              <div
                className="overflow-hidden position-relative hover"
                key={index}
                style={{
                  border: "1px solid #d9d9d9",
                  padding: "8px",
                  borderRadius: "4px",
                  marginRight: "10px",
                  marginBottom: "10px",
                  transition: "filter 0.3s",
                }}
                onMouseEnter={() => this.handleMouseEnter(index)}
                onMouseLeave={this.handleMouseLeave}
              >
                <div
                  className="position-relative overflow-hidden"
                  style={{
                    width: "85px",
                    height: "85px",
                  }}
                >
                  {isImage ? (
                    // Render a link for URLs
                    <a href={file} target="_blank" rel="noopener noreferrer">
                      <img
                        className="w-100 h-100 object-fit-cover"
                        src={previewSrc}
                        alt={`Attachment ${index}`}
                        style={{
                          filter:
                            hoverIndex === index ? "brightness(50%)" : "none",
                          transition: "filter 0.3s",
                        }}
                      />
                    </a>
                  ) : (
                    // Render the file object
                    <iframe
                      className="w-100 h-100 object-fit-cover"
                      src={previewSrc}
                      title="Image"
                      style={{
                        filter:
                          hoverIndex === index ? "brightness(50%)" : "none",
                        transition: "filter 0.3s",
                      }}
                      onClick={() => this.handlePreview(index)}
                    />
                  )}
                  {hoverIndex === index && (
                    <div
                      className="d-flex position-absolute justify-content-center align-items-center w-100 h-100"
                      style={{
                        top: "0",
                        left: "0",
                      }}
                    >
                      <div className="d-flex justify-content-center align-items-center flex-row gap-2">
                        {file && (
                          // Render preview icon only for file objects
                          <i
                            className="bi bi-eye  text-white cursor-pointer"
                            // onClick={() => this.handlePreview(index)}
                            onClick={() => {
                              const previewURL =
                                typeof file === "string"
                                  ? file
                                  : URL.createObjectURL(file);
                              console.log("Preview: ", previewURL);
                              window.open(previewURL, "_blank");
                            }}
                            title="Preview file"
                          ></i>
                        )}
                        {!this.props.disabled && (
                          <button
                            className="bi bi-trash text-white cursor-pointer bg-transparent border-0"
                            onClick={() => this.handleDelete(index)}
                            title="Remove file"
                          ></button>
                        )}
                      </div>
                    </div>
                  )}
                </div>
                <div
                  className="position-absolute text-center overflow-hidden text-truncate nowrap"
                  style={{
                    fontSize: "12px",
                    maxWidth: "90px",
                    marginTop: "-15px",
                  }}
                >
                  {/* Render file name */}
                  {/* {typeof file === "string" ? "URL" : file.name} */}
                </div>
              </div>
            );
          })}
        </div>
        {/* <div style={{ color: "#d3d3d3", marginTop: "1rem" }}>
          <p>Maximum upload file size: 2MB</p>
        </div> */}
        {error && (
          <div style={{ color: "red", marginBottom: "1rem" }}>
            <p>{error}</p>
          </div>
        )}

        {showModal && previewImage && (
          <div
            className="d-flex align-items-center justify-content-center w-100 h-100 position-fixed"
            style={{
              backgroundColor: "rgba(0, 0, 0, 0.5)",
              zIndex: "9999",

              left: "0",
            }}
            onClick={this.handleCloseModal}
          >
            {(() => {
              const isImage =
                typeof previewImage === "string"
                  ? isImageUrl(previewImage)
                  : isImageUrl(previewImage.name);
              const previewSrc =
                typeof previewImage === "string"
                  ? previewImage
                  : URL.createObjectURL(previewImage);

              return isImage ? (
                <img
                  src={previewSrc}
                  alt="Upload Attachment"
                  // className="w-75 h-75"
                  // style={{
                  //   border: "3px solid",
                  // }}
                  title="File Preview"
                />
              ) : (
                <iframe
                  src={previewSrc}
                  className="w-75 h-75"
                  style={{
                    border: "3px solid",
                  }}
                  title="File Preview"
                />
              );
            })()}
          </div>
        )}
      </>
    );
  }
}

export default FileUpload;
